import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import calendarIcon from '../../assets/icons/calendarIcon.svg';
import locationIcon from '../../assets/icons/locationIcon.svg';
import { convertWeekdaysReverse, toHumanDate, transformTimeFormat } from '../../utils/data';
import { convertedArrayReverse, isExpiredOpp } from '../../utils/methods';
import { AvatarFromAws } from '../avatarFromAws/AvatarFromAws';
import { useStyles } from './cards.style';
import { IProps } from './types';

export const Card = ({ item }: IProps): JSX.Element => {
  const classes = useStyles();
  const { name, categories, startDate, endDate, address, frequency, pictureUrl } = item;
  const convertedArray = convertedArrayReverse(categories);

  const frequencyShow = useMemo(() => {
    if (frequency[0] === 'ONE_DAY') {
      return toHumanDate(startDate, 'd MMM yyyy');
    }
    return convertWeekdaysReverse[frequency[0]];
  }, [startDate]);

  return (
    <Box
      className={`${classes.mainBlock} ${isExpiredOpp(item.endDate, item.frequency[0]) && classes.mainCancelledBlock}`}
    >
      <Box className={classes.imageBlock}>
        <AvatarFromAws photoKey={pictureUrl} className={classes.image} notPublic />
        <div className={classes.goalsBlock}>
          {convertedArray.map((goal: string) => (
            <span className={classes.goal}>{goal}</span>
          ))}
        </div>
      </Box>
      <Box className={classes.nameBlock}>
        <h3 className={classes.name}>
          {name}
        </h3>
      </Box>
      <Box className={classes.infoBlock}>
        <div>
          <img src={calendarIcon} style={{ width: '22px' }} />
        </div>
        <div className={classes.contentBlock}>
          <span className={classes.mainInfo}>{frequencyShow}</span>
          <span className={classes.secondaryInfo}>
            {`${transformTimeFormat(startDate)} - ${transformTimeFormat(endDate)}`}
          </span>
        </div>
      </Box>
      <Box className={classes.infoBlock}>
        <div>
          <img src={locationIcon} style={{ width: '22px' }} />
        </div>
        <div className={classes.contentBlock}>
          <span className={classes.mainInfo2}>{address}</span>
          <span className={classes.secondaryInfo}>{address}</span>
        </div>
      </Box>
    </Box>
  );
};
